<div class="search-result-placeholder">
    <div class="search-result-placeholder__text">{{text}}</div>
    <div class="search-result-placeholder__img"></div>
</div>
